import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
const AdminLogin = Loadable(lazy(() => import('views/admin-components/pages/authentication/AdminLogin')));
const LandingPage = Loadable(lazy(() => import('views/user-components/pages/LandingPage/LandingPage')));

let loginType = localStorage.getItem('login_type');

const isAdminLogin = (loginType === 'admin')
const isClientLogin = loginType === 'client'

const PublicRoute = {
    path: '/',
    element: <MinimalLayout />,
    children: [

        {
            path: '/',
            element: isClientLogin ? <Navigate to={'/'} /> : <LandingPage />, //redirect to sign page if not login super user.

        },

        {
            path: '/admin',
            element: (isAdminLogin) ? <Navigate to={'/admin/demo-requests'} /> : <AdminLogin />
        },

        // { path: '*', element: isSuperUserLogin ? <DashboardDefault /> : <Navigate to={'/admin'} /> }, // NOT FOUND  PAGE
    ]
};
export default PublicRoute;
